import { find, round } from 'lodash';

import { DisplayListItem, DisplayPageBlock, DisplayRegion, Screen, SelectedScreens } from '../../typings/displayMap';

export class PlacementsMapHelpers {
    static getOutdoorCheckedByRegion(
        screenGroupsByRegion: {
            [id: string]: DisplayListItem[];
        },
        pageBlocks: DisplayPageBlock[] = []
    ): SelectedScreens {
        const slected: string[] = pageBlocks.map(pageBlock =>
            PlacementsMapHelpers.createPageBlockId(pageBlock.pageId, pageBlock.impId)
        );
        const checkedByRegion: SelectedScreens = {};

        Object.keys(screenGroupsByRegion).forEach((regionId: string) => {
            screenGroupsByRegion[regionId].forEach((item: DisplayListItem) => {
                if (slected.includes(item.id)) {
                    if (checkedByRegion[regionId]) {
                        checkedByRegion[regionId].push(item.id);
                    } else {
                        checkedByRegion[regionId] = [item.id];
                    }
                }
            });
        });

        return checkedByRegion;
    }

    static checkedByRegionToPageBlocks(checkedByRegion: SelectedScreens): DisplayPageBlock[] {
        return Object.keys(checkedByRegion).reduce((pageBlocks, regionId): DisplayPageBlock[] => {
            return [
                ...pageBlocks,
                ...checkedByRegion[regionId].map(
                    (id: string): DisplayPageBlock => PlacementsMapHelpers.parsePageBlockId(id)
                )
            ];
        }, []);
    }

    static outdoorCheckedByRegionToPageBlocks(
        screenGroupsByRegion: {
            [id: string]: DisplayListItem[];
        },
        checkedByRegion: SelectedScreens
    ): DisplayPageBlock[] {
        return Object.keys(checkedByRegion).reduce((pageBlocks, regionId): DisplayPageBlock[] => {
            return [
                ...pageBlocks,
                ...checkedByRegion[regionId]
                    .filter(id => {
                        return (
                            screenGroupsByRegion[regionId] &&
                            Boolean(
                                find(screenGroupsByRegion[regionId], {
                                    id: id
                                })
                            )
                        );
                    })
                    .map((id: string): DisplayPageBlock => PlacementsMapHelpers.parsePageBlockId(id))
            ];
        }, []);
    }

    static indoorCheckedByRegionToPageBlocks(
        screenGroupsByRegion: {
            [id: string]: DisplayListItem[];
        },
        checkedByRegion: SelectedScreens
    ): DisplayPageBlock[] {
        return Object.keys(checkedByRegion).reduce((pageBlocks, regionId): DisplayPageBlock[] => {
            let checked: DisplayPageBlock[] = [];

            checkedByRegion[regionId].forEach(pageZoneId => {
                const item: DisplayListItem | undefined = find(screenGroupsByRegion[regionId], { id: pageZoneId });

                if (item) {
                    checked = [
                        ...checked,
                        ...item.screens.map(screen => PlacementsMapHelpers.parsePageBlockId(screen.id))
                    ];
                }
            });

            return [...pageBlocks, ...checked];
        }, []);
    }

    static parsePageBlockId(id: string): DisplayPageBlock {
        const splited = id.split(':');

        return {
            pageId: splited[0],
            impId: splited[1]
        };
    }

    static createPageBlockId(page: string, block: string): string {
        return page + ':' + block;
    }

    static createPageZoneId(page: string, zoneCategory: string | number): string {
        return page + ':' + zoneCategory;
    }

    static formatCoordinates(coordinates: string): number[] {
        return coordinates.split(/,\s?/).map(value => {
            // DIRECT-96745: Решить проблему с очень близко расположенными щитами
            return round(Number(value), 5);
        });
    }

    static getIndoorCheckedByRegion(
        screenGroupsByRegion: {
            [id: string]: DisplayListItem[];
        },
        pageBlocks: DisplayPageBlock[] = []
    ): SelectedScreens {
        const slected: string[] = pageBlocks.map(pageBlock =>
            PlacementsMapHelpers.createPageBlockId(pageBlock.pageId, pageBlock.impId)
        );
        const checkedByRegion: SelectedScreens = {};

        Object.keys(screenGroupsByRegion).forEach((regionId: string) => {
            screenGroupsByRegion[regionId].forEach((item: DisplayListItem) => {
                item.screens.some((screen: Screen) => {
                    if (slected.includes(screen.id)) {
                        if (checkedByRegion[regionId]) {
                            checkedByRegion[regionId].push(item.id);
                        } else {
                            checkedByRegion[regionId] = [item.id];
                        }

                        return true;
                    }

                    return false;
                });
            });
        });

        return checkedByRegion;
    }

    static filterDeletedPlacements(
        screenGroupsByRegion: {
            [id: string]: DisplayListItem[];
        },
        pageBlocks: DisplayPageBlock[] = []
    ): {
        [id: string]: DisplayListItem[];
    } {
        const selected = pageBlocks.map((pageBlock: DisplayPageBlock) =>
            PlacementsMapHelpers.createPageBlockId(pageBlock.pageId, pageBlock.impId)
        );
        const newScreenGroupsByRegion: {
            [id: string]: DisplayListItem[];
        } = {};

        Object.keys(screenGroupsByRegion).forEach((regionId: string) => {
            const regionScreen = screenGroupsByRegion[regionId].reduce(
                (screenGroups: DisplayListItem[], item: DisplayListItem) => {
                    const screens = item.screens.filter((screen: Screen) => {
                        return !screen.isDeleted || selected.includes(screen.id);
                    });

                    if (Boolean(screens.length)) {
                        screenGroups.push({
                            ...item,
                            screens: screens
                        });
                    }

                    return screenGroups;
                },
                []
            );

            if (Boolean(regionScreen.length)) {
                newScreenGroupsByRegion[regionId] = regionScreen;
            }
        });

        return newScreenGroupsByRegion;
    }

    static filterDeletedRegions(commonRegions: DisplayRegion[], screenGroupsRegions: string[]): DisplayRegion[] {
        return commonRegions.filter((region: DisplayRegion) => screenGroupsRegions.includes(region.id));
    }
}
